/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useMutation } from 'react-query'

import Input from 'Components/Input'
import Eye from 'Assets/Icons/Eye'
import { ReactComponent as CloseEye } from 'Assets/Icons/closeEye.svg'
import { ReactComponent as Email } from 'Assets/Icons/email.svg'
import { addToken, verifyLength } from 'helpers'
import { route } from 'Routes/Route'
import Button from 'Components/Button'
import { loginApi } from 'Query/Auth/Auth.mutation'
import { userContext } from 'context/user'
import Toaster from 'Components/Toaster'

function Login() {
  const navigate = useNavigate()
  const { dispatch } = useContext(userContext)

  const [err, setErr] = useState(null)
  const [email, setEmail] = useState('')
  const [errEmail, setErrEmail] = useState('')

  const [password, setPassword] = useState('')
  const [errPassword, setErrPassword] = useState('')

  const [show, setShow] = useState(false)

  const { isLoading, mutate, isError, error } = useMutation(loginApi, {
    onSuccess: (data) => {
      addToken(data?.data?.sJwtToken)
      navigate(route.dashboard)
    },
    onError: (e) => {
      setEmail('')
      setPassword('')
      setErr(e?.response?.data?.sMessage)
    },
  })

  function handleChange(e, type) {
    e.preventDefault()
    switch (type) {
      case 'Email':
        if (verifyLength(e.target.value, 1)) {
          setErrEmail('')
        } else if (!verifyLength(e.target.value, 1)) {
          setErrEmail('Required field')
        }
        setEmail(e.target.value)
        break
      case 'Password':
        if (verifyLength(e.target.value, 1)) {
          setErrPassword('')
        } else if (!verifyLength(e.target.value, 1)) {
          setErrPassword('Required field')
        }
        setPassword(e.target.value)
        break
      default:
        break
    }
  }
  function logIn(e) {
    e.preventDefault()
    if (verifyLength(email, 1) && verifyLength(password, 1)) {
      mutate({ sEmail: email, sPassword: password })
    } else {
      if (!verifyLength(email, 1)) {
        setErrEmail('This field is required')
      }
      if (!verifyLength(password, 1)) {
        setErrPassword('This field is required')
      }
    }
  }



  return (
    <>
      <div className="d-flex ">
        {/* <div className="left-container"></div> */}
        <div className="right-container">
          <section className="d-flex justify-content-center align-items-center authForm_section">
            <form className="authForm" onSubmit={logIn}>
              <div className="d-flex flex-column justify-content-evenly align-items-center authFormTitle">
                <h1 className="titleLogin m-4">Mehrangi</h1>
                <h3>Sign in</h3>
                <h6>Sign in and start managing your content!</h6>
              </div>
              <div className="d-flex mt-2 flex-column justify-content-center align-items-center">
                <Input
                  id="email"
                  labelText="Email"
                  type="text"
                  placeholder="Enter Email Address"
                  value={email}
                  errorMessage={errEmail}
                  onChange={(e) => {
                    handleChange(e, 'Email')
                  }}
                  startIcon={<Email />}
                  className="ps-5"
                />
                <Input
                  id="password"
                  labelText="Password"
                  type={show ? 'text' : 'password'}
                  value={password}
                  placeholder="Enter Your Password"
                  errorMessage={errPassword}
                  onChange={(e) => {
                    handleChange(e, 'Password')
                  }}
                  startIcon={show ? <Eye onClick={() => setShow(false)} /> : <CloseEye onClick={() => setShow(true)} />}
                  className="ps-5"
                />
                 <Link to={route.forgotPassword} className="b-link mb-2">
                  Forgot Password?
                </Link>
                <Button loading={isLoading} className="mt-4 primary" fullWidth>
                  Login
                </Button>
               
                <p className="errorResponse">{err && err}</p>
              </div>
            </form>
          </section>
        </div>
      </div>
    </>
  )
}

export default Login
